import { useParams } from 'react-router-dom';
import { useHelpCategory } from '~/components/Help/Help.hooks';
import { HelpCategory } from './HelpCategory';

export const HelpCategoryContainer = () => {
  const { categoryId } = useParams<{ categoryId: string }>();
  const { data: category } = useHelpCategory(categoryId, { keepPreviousData: true });

  return category ? <HelpCategory {...category} /> : null;
};
